<svelte:head>
  <title>{scoped.data?.title || "Need" } | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="block is-size-7"><a href={$url('../../needs')}> &lt; Back to all needs</a></div>

{#if scoped.data}
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">{scoped.data.title} <span class="tag is-small">{scoped.data.status}</span></h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">
      {#if scoped.data.status === 'published'}
      <button
            class="button" on:click={() =>
              ($uiState.activeModal = {
                component: ConfirmClose,
                props: { id: id }
              })}>
            <span>End Need</span>
      </button>
      {/if}
      
      {#if stage === 'details'}
      <button class="button" on:click={() => {
            $uiState.activeModal = { component: ConfirmDelete, props: { item: { data: scoped.data, id }, navPath } };
          }}>
          Delete
        </button>
      {/if}

    </div>
  </nav>

  <div class="tabs">
    <ul>
      <Tab
        page="details"
        label="Details" />
    </ul>
  </div>

  <slot scoped={scoped} />
{/if}

<script lang="ts">
  export let id :NeedId;

  import { uiState } from "../../../../lib/uiState";
  import { params } from "@sveltech/routify";
  import { url } from "@sveltech/routify";
  import _ from "lodash";

  import Tab from "./_components/Tab.svelte";
  import ConfirmClose from "./_components/ConfirmClose.svelte";
  import ConfirmDelete from "./_components/ConfirmDelete.svelte";


  let firebase = window.firebase;

  let stage : 'details' | undefined;

  let navPath = '/charity/needs';

  // create object that can be passed to child pages
  $: scoped = {
    id,
    data: (undefined as Need_v1 | undefined),
  };

    $: if (scoped.data) {
    const status : OfferStatus = scoped.data.status;

    stage = 'details'

    if ($params.action === "end" && scoped.data.status === 'published') {
      $uiState.activeModal = {
        component: ConfirmClose,
        props: { id: id }
      };
    }
  }

  getNeed();

  function getNeed(): void {
    firebase
      .firestore()
      .collection("needs_v1")
      .doc(id)
      .onSnapshot((doc) => {
        scoped.data = doc.data() as Need_v1;
      });
  }

</script>